// extracted by mini-css-extract-plugin
export default {"pictureBlock":"Picture_pictureBlock__3SWfI","media":"Picture_media__zPzDW","whiteBg":"Picture_whiteBg__agHYS"};